<template>
	<v-col class="ma-0 pa-0" cols="12" id="head_title">
		<v-col class="pa-0" cols="12" id="main_content_minwidthset">
			<v-row class="ma-0 pa-0 pl-3 pr-3" align="center" id="header_height">
				<v-col class="ma-0 pa-0" cols="auto">
					<v-row class="ma-0 pa-0" align="center">
						<router-link :to="{ path: $routerHistory.previous().path }"
							style="color:transparent;">
							<v-col class="ma-0 pa-0" cols="auto" align="center"
								style="color:#08B0FF;font-size:1rem;text-align:center;">
								{{'UI 테스트'}}
							</v-col>
						</router-link>
						<v-img max-height="50px" max-width="1.5rem" class="ma-0 pa-0 mr-3"
							src="@/assets/images/history_arrow.png"></v-img>
						<v-col class="ma-0 pa-0" cols="auto">
							{{title}}
						</v-col>
					</v-row>
				</v-col>
      </v-row>
		</v-col>
	</v-col>
</template>

<script>
import mixin from '@/mixin';
export default {
	props: {
		title: { type: String, default: '' }
	},
	components: {
		
	},
	mixins: [mixin.common],
	data: () => ({
		
	}),
}
</script>

<style lang="scss" scoped>

</style>